import {hasSession} from "@/utils/helpers";
import firebase from "firebase";

async function loginWithCustomToken(token, next) {
    try {
        await firebase.auth().signInWithCustomToken(token)
        return next({path: '/products'})
    } catch (e) {
        console.error('Error signing in with token', e)
    }
}


export default async function auth({next, to: {query: {token}}}) {

    if (token) {
        return loginWithCustomToken(token, next)
    } else {
        const hasAuth = hasSession()

        if (!hasAuth) {
            return next('/login')
        }
        return next()
    }
}
